<template>
    <ModalContainer v-if="appointmentDetail" :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close"  @click="$emit('close-calendar-appointment-modal')"><i class="las la-times"></i></button>
            <h4 style="text-transform: capitalize;" class="modal-title">{{getLongDateFromISO(appointmentDetail.date)}}</h4>
        </template>
        <template v-slot:body>
            <h2>{{$t('components.appointment.title_tiny', {rate_name: appointmentDetail.rate_name, chaired_admin_name:appointmentDetail.chaired_admin_name })}}</h2>
            <p>{{$t('components.appointment.people_reserved', {reservation_count: appointmentDetail.reservation_count, max_participant: appointmentDetail.max_participant})}}</p>
            <table v-if="appointmentDetail.reservations_active.length !== 0" class="table">
                <tbody>
                    <tr v-for="reservation in appointmentDetail.reservations_active" v-bind:key="reservation.id">
                        <td>
                            <div class="row">
                                <div class="col-xs-12 col-md-6">
                                    <p v-bind:class="{ 'text-muted': appointmentDetail.no_show_clients.includes(reservation.client.id)}">
                                        {{reservation.client.first_name}} {{reservation.client.last_name}} <br>
                                        <a v-if="appointmentDetail.is_online" href="" @click.prevent.stop="getJoinMeetingUrl(reservation.id)">{{$t('components.appointment.personal_link')}} <i class="las la-external-link-alt"></i></a>

                                    </p>
                                </div>
                                <div class="col-xs-12 col-md-6">
                                    <div class="btn-toolbar pull-right">
                                        <span v-if="appointmentDetail.start_date_in_past">
                                            <a v-if="appointmentDetail.no_show_clients.includes(reservation.client.id)" class="btn btn-default" href="" @click.prevent.stop="showClientAppointmentClick(reservation.client.id, appointmentDetail.id)"><i class="las la-user-minus text-muted"></i><span class="text-muted">{{$t('components.appointment.absent')}}</span></a>
                                            <a v-else class="btn btn-default" href="" @click.prevent.stop="noShowClientAppointmentClick(reservation.client.id, appointmentDetail.id)"><i class="las la-user-check text-success"></i><span class="text-success">{{$t('components.appointment.present')}}</span></a>
                                        </span>
                                        <a class="btn btn-danger" href="" @click.prevent.stop="cancelReservationClick(reservation.id)"><i class="las la-calendar-times"></i>{{$t('common.delete')}}</a>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else>
                <span class="text-muted">{{$t('components.appointment.no_reservation')}}</span>
            </div>
            <div v-if="appointmentDetail.is_online" class="margin-bottom-20 margin-top-20">
                <a class="btn btn-primary btn-lg btn-block" href="" @click.prevent.stop="startLessonClick">
                    <i class="las la-video"></i>
                    {{$t('components.appointment.start_meeting')}}
                </a>
            </div>
        </template>

        <template v-slot:footer>
            <a class="btn btn-danger" href="" @click.prevent.stop="cancelAppointmentClick">
                <i class="las la-calendar-times"></i>
                {{$t('components.appointment.delete')}}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import {
        cancelAppointment,
        cancelReservation,
        getAppointmentDetail, getJoinMeetingUrl,
        noShowClientAppointment,
        showClientAppointment
    } from "../../api";
    import {Utils} from "../../common/utils";
    import ModalContainer from "./ModalContainer";

    export default {
        name: "CalendarAppointmentDetailModal",
        components: {ModalContainer},
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            appointmentId: {
                type: Number,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                errorMessage: "",
                appointmentDetail: {
                    reservations_active: []
                }
            }
        },
        watch: {
            async appointmentId(newVal) {
                this.loading = true;
                try {
                    this.appointmentDetail = await getAppointmentDetail(newVal);
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            }
        },
        methods: {
            getLongDateFromISO(date){
                return Utils.getLongDateFromISO(date)
            },
            async showClientAppointmentClick(client_id, appointment_id) {
                this.loading = true;
                try {
                    await showClientAppointment(client_id, appointment_id);
                    this.appointmentDetail = await getAppointmentDetail(this.appointmentId);
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            async cancelReservationClick(reservation_id) {
                this.loading = true;
                try {
                    await cancelReservation(reservation_id);
                    this.appointmentDetail = await getAppointmentDetail(this.appointmentId);
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },

            async getJoinMeetingUrl(reservation_id) {
                this.loading = true;
                try {
                    let joinMeetingUrl = await getJoinMeetingUrl(this.appointmentId, reservation_id);
                    window.open(joinMeetingUrl, '_blank');
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            startLessonClick() {
                if (this.appointmentDetail.meeting_start_url) {
                    window.open(this.appointmentDetail.meeting_start_url, "_blank");
                } else if (this.appointmentDetail.zoom_start_url) {
                    window.open(this.appointmentDetail.zoom_start_url, "_blank");
                }
            },
            async cancelAppointmentClick() {
                //TODO add success message and confirm
                this.loading = true;
                try {
                    await cancelAppointment(this.appointmentDetail.id);
                    this.loading = false;
                    this.$emit('close-calendar-appointment-modal')
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            async noShowClientAppointmentClick(client_id, appointment_id) {
                //TODO add success message and confirm
                this.loading = true;
                try {
                    await noShowClientAppointment(client_id, appointment_id);
                    this.appointmentDetail = await getAppointmentDetail(this.appointmentId);
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
        }
    }
</script>

<style scoped>

</style>